export default {
  layout: {
    tabEvents: "Eventos económicos",
    eventsDescription:
      "Eventos económicos e instantáneas de reparto en el libro mayor",
    tabExternal: "Pagos externos",
    externalDescription: "Pagos externos del PSP",
    tabSettlements: "Liquidaciones",
    settlementsDescription: "Líneas de liquidación abiertas por beneficiario",
  },
  shared: {
    emptyCell: "—",
    colCreated: "Creado",
    colType: "Tipo",
    colStatus: "Estado",
    colAmount: "Importe",
  },
  eventsList: {
    loadError: "No se pudieron cargar los eventos económicos",
    colGross: "Bruto",
    colMethod: "Método",
    colLines: "Líneas",
    colExternalPayment: "Pago",
    openRowAria: "Abrir evento {{id}}",
    eventType: {
      CHECKOUT_CAPTURED: "Checkout",
      BOOKING_PAYMENT_CAPTURED: "Pago de reserva",
      SELLER_FEE_FROM_RECEIPT: "Comisión de ticket",
      REFUND_REVERSAL: "Reversión de reembolso",
      SELLER_BANK_TRANSFER_SENT: "Transferencia enviada",
      SELLER_BANK_TRANSFER_RECEIVED: "Transferencia recibida",
    },
    eventStatus: {
      DRAFT: "Borrador",
      POSTED: "Contabilizado",
      REVERSED: "Revertido",
    },
    allocationMethod: {
      USER_PAYMENT: "Pago de usuario",
      SELLER_FEE: "Comisión del vendedor",
      REFUND: "Reembolso",
      TREASURY_SETTLEMENT: "Liquidación de tesorería",
    },
  },
  externalList: {
    statusAll: "Todos los estados",
    openRowAria: "Mostrar pago {{id}}",
    loadError: "No se pudieron cargar los pagos externos",
    statusCountsLoadError: "No se pudieron cargar los recuentos por estado",
    linkedPayment: "Pago vinculado",
    clearHighlight: "Quitar resaltado",
    selectedPayment: "Pago seleccionado",
    providerFlow: "Proveedor / flujo",
    providerPaymentId: "ID de pago del proveedor",
    idempotencyKey: "Clave de idempotencia",
    booking: "Reserva",
    paymentId: "ID de pago",
    colProviderRef: "Ref. proveedor",
    colBooking: "Reserva",
    colPaymentId: "ID de pago",
    paymentStatus: {
      CREATED: "Creado",
      AUTHORIZED: "Autorizado",
      CAPTURED: "Cobrado",
      FAILED: "Fallido",
      CANCELED: "Cancelado",
      REFUNDED: "Reembolsado",
      REFUND_FAILED: "Reembolso fallido",
      PENDING: "Pendiente",
      AWAITING_APP: "Esperando app",
      PENDING_RECONCILIATION: "Conciliación pendiente",
      COMPLETED: "Completado",
      REVERTED: "Revertido",
    },
    paymentType: {
      CHECKOUT_PAYMENT: "Pago de checkout",
      SELLER_PAYOUT: "Pago al vendedor",
    },
    provider: {
      SUMUP: "SumUp",
      MOCK: "Mock",
      REVOLUT: "Revolut",
    },
    flow: {
      CLOUD_POS: "Cloud POS",
      BANK_TRANSFER: "Transferencia bancaria",
    },
  },
  eventDetail: {
    splitAria: "Reparto por rol",
    technicalTitle: "Datos técnicos",
    technicalHint: "Instantánea de reglas de reparto y metadatos sin procesar",
    roles: {
      PROCESSOR_FEES: "Comisiones del procesador",
      SELLER: "Vendedor",
      HOST: "Host",
      SALES_AGENT_ACTIVITY: "Agente de ventas (actividad)",
      SALES_AGENT_HOUSE: "Agente de ventas (casa)",
      PLATFORM: "Plataforma",
      TREASURY_CLEARING: "Compensación de tesorería",
    },
    loadError: "No se pudo cargar el evento",
    loading: "Cargando evento…",
    notFound: "Evento no encontrado.",
    backToEvents: "Volver a eventos",
    allEvents: "Todos los eventos",
    viewExternalPayment: "Ver pago",
    cardTitle: "Evento económico",
    currency: "Divisa",
    grossAmount: "Importe bruto",
    idempotencyKey: "Clave de idempotencia",
    ledgerEntries: "Asientos del libro mayor",
    bookingId: "ID de reserva",
    checkoutId: "ID de checkout",
    reversesEvent: "Anula evento",
    updated: "Actualizado",
    jsonAllocationSnapshot: "Instantánea de reglas de reparto",
    jsonMetadata: "Metadatos",
    jsonNone: "Ninguno",
    allocationLinesTitle: "Líneas de reparto",
    allocationLinesSubtitle:
      "Instantánea congelada registrada en el libro mayor ({{count}} líneas)",
    colStep: "Paso",
    colRole: "Rol",
    colStoredPercent: "% almacenado",
    colAbsolutePercent: "% absoluto",
    colLedgerAccount: "Cuenta del libro mayor",
    colLineId: "ID de línea",
    noAllocationLines: "Sin líneas de reparto",
  },
  settlements: {
    roles: {
      seller: "Vendedor",
      host: "Host",
      salesAgent: "Agente comercial",
    },
    payees: {
      kpiPayeeCount_one: "{{count}} beneficiario",
      kpiPayeeCount_other: "{{count}} beneficiarios",
      loadError: "No se pudieron cargar los beneficiarios",
      searchPlaceholder: "Nombre o email",
      filterRole: "Rol",
      filterAllRoles: "Todos los roles",
      filterDefault: "Abiertas",
      filterToBePaid: "Por pagar",
      filterToBeInvoiced: "Por facturar",
      colName: "Beneficiario",
      colRole: "Rol",
      colPayable: "Por pagar",
      colCommissionOpen: "Comisión por emitir",
      colSupplierOpen: "En espera fact. proveedor",
      legalIncompleteTooltip: "Datos legales incompletos",
      openRowAria: "Abrir beneficiario {{name}}",
      amountWithCount: "{{amount}} ({{count}})",
      empty: "No se encontraron beneficiarios",
    },
    detail: {
      loadError: "No se pudieron cargar las líneas de liquidación",
      loading: "Cargando líneas…",
      back: "Volver a beneficiarios",
      linesTitle: "Líneas de liquidación",
      linesSubtitle:
        "Selecciona las líneas que determinan las acciones del panel derecho.",
      flowFilter: "Flujo",
      paymentFilter: "Pago",
      invoiceFilter: "Factura",
      flowFilterAll: "Todos",
      flowFilterUpfront: "Actividad upfront",
      flowFilterReceiptBased: "Actividad por recibo",
      flowFilterOutgoingCommissions: "Comisiones salientes",
      paymentFilterAll: "Todos",
      paymentFilterUnpaid: "No pagados",
      paymentFilterPaid: "Pagados",
      paymentFilterUncollected: "Por cobrar",
      paymentFilterCollected: "Cobrados",
      invoiceFilterAll: "Todas",
      invoiceFilterUninvoiced: "Por facturar",
      invoiceFilterInvoiced: "Facturadas",
      invoiceFilterPending: "Pendientes",
      invoiceFilterReceived: "Recibidas",
      deselectAll: "Deseleccionar todas",
      emptyFiltered: "Ninguna línea coincide con los filtros actuales",
      filteredCount: "{{shown}} de {{total}} líneas",
      invoiceToInvoice: "Por facturar",
      invoiceInvoiced: "Facturada",
      invoiceSummaryNotSent: "Resumen no enviado",
      invoiceAwaitingInvoice: "Factura pendiente",
      invoiceReceived: "Factura recibida",
      paymentAwaiting: "Pendiente",
      paymentReceived: "Recibido",
      paymentToPay: "Por pagar",
      paymentPaid: "Pagado",
      paymentNotAvailable: "No disponible",
      copyCollectionReference: "Copiar referencia de cobro",
      copyInvoiceReference: "Copiar referencia de factura",
      copyPaymentReference: "Copiar referencia de pago",
      actionsPanelTitle: "Acciones",
      actionsPanelSubtitle:
        "Ejecuta los pasos de liquidación para las líneas seleccionadas.",
      selectionSummaryTitle: "Resumen de selección",
      readOnlyHint: "Tienes acceso de solo lectura a esta liquidación.",
      finalizedReadOnlyHint:
        "Esta liquidación está facturada y pagada, por lo que los campos son de solo lectura.",
      noActionsHint: "Selecciona líneas para ver las acciones disponibles.",
      selectMetricPayable: "Seleccionar líneas por pagar",
      selectMetricInvoiceable: "Seleccionar líneas con comisión por emitir",
      selectMetricCollectible: "Seleccionar líneas por cobrar",
      selectMetricSupplierInvoice:
        "Seleccionar líneas en espera de factura proveedor",
      openPayable: "Por pagar",
      openInvoiceable: "Comisión por emitir",
      openPendingSupplierInvoice: "En espera factura proveedor",
      openCollectible: "Por cobrar",
      selectAll: "Seleccionar todas",
      selectLine: "Seleccionar línea para {{activity}}",
      colEvent: "Evento",
      colInvoiceAmount: "Importe factura",
      colInvoiceStatus: "Estado factura",
      moneyDirectionOutgoing: "Dinero saliente",
      moneyDirectionIncoming: "Dinero entrante",
      colPaymentAmount: "Importe pago",
      colPaymentStatus: "Estado pago",
      viewFePdf: "Ver",
      downloadFePdf: "Descargar",
      downloadFePdfError:
        "No se pudo descargar el PDF de la factura de comisión",
      empty: "No hay líneas de liquidación",
      selectedPayable: "Pagable seleccionado",
      selectedInvoiceable: "Facturable seleccionado",
      selectedCount: "Líneas seleccionadas",
      markInvoiced: "Marcar facturado",
      markPaid: "Marcar pagado",
      invoiceNotePlaceholder: "Nota para factura de comisión (opcional)",
      collectionNotePlaceholder: "Nota para cobro (opcional)",
      supplierNotePlaceholder: "Nota para factura proveedor (opcional)",
      paymentNotePlaceholder: "Nota para pago (opcional)",
      referencePlaceholder: "Referencia de transferencia",
      referenceRequired: "La referencia de pago es obligatoria",
      invoicedSuccess: "Líneas seleccionadas marcadas como facturadas",
      invoicedError: "No se pudieron marcar las líneas como facturadas",
      paidSuccess: "Líneas seleccionadas marcadas como pagadas",
      paidError: "No se pudieron marcar las líneas como pagadas",
      selectedCollectible: "Seleccionado a cobrar",
      viewSupplierInvoice: "Ver factura",
      downloadSupplierInvoice: "Descargar factura",
      downloadSupplierInvoiceError:
        "No se pudo descargar la factura del proveedor",
      flowLabel: {
        UPFRONT: "Pago por adelantado",
        RECEIPT_BASED: "Pago receipt-based",
        SUPPLIER_PAYOUT: "Pago al proveedor",
      },
      flowHint: {
        UPFRONT:
          "Dinero ya cobrado: emite la factura de comisión y paga al vendedor.",
        RECEIPT_BASED: "Cobra el importe y luego emite la factura.",
        SUPPLIER_PAYOUT:
          "Envía el resumen, registra la factura recibida y luego paga al vendedor.",
      },
      mixedSelectionWarning:
        "Las líneas seleccionadas pertenecen a flujos de liquidación distintos. Reduce la selección a un solo flujo antes de ejecutar acciones.",
      emailNever: "Nunca enviado",
      emailLast: "Último envío {{when}}",
      emailSentCount: "Enviado {{count}}×",
      steps: {
        summaryTitle: "Enviar resumen",
        summaryDesc:
          "Envía al vendedor el resumen de las transacciones seleccionadas (PDF adjunto).",
        summaryButton: "Enviar email de resumen",
        summaryResend: "Reenviar resumen",
        proformaTitle: "Enviar pro forma",
        proformaDesc:
          "Envía al vendedor la pro forma de las líneas de comisión seleccionadas antes de registrar el cobro.",
        proformaButton: "Enviar email de pro forma",
        proformaResend: "Reenviar pro forma",
        summarySuccess: "Email de resumen enviado",
        summaryError: "No se pudo enviar el email de resumen",
        summaryAllInvoiced:
          "Todas las líneas seleccionadas ya están facturadas",
        summarySkipped: "Email no enviado: {{detail}}",
        invoiceTitle: "Emitir factura",
        invoiceDesc:
          "Emite la factura de comisión para las líneas seleccionadas.",
        collectTitle: "Registrar cobro",
        collectDesc:
          "Registra el pago recibido del vendedor para las líneas seleccionadas.",
        collectButton: "Registrar cobro",
        collectSuccess: "Cobro registrado",
        collectError: "No se pudo registrar el cobro",
        collectReferencePlaceholder: "Referencia de la transferencia entrante",
        supplierTitle: "Registrar factura recibida",
        supplierDesc:
          "Sube la factura emitida por el vendedor (un PDF puede cubrir varias líneas).",
        supplierRegisteredDesc:
          "Esta selección ya tiene una factura de proveedor registrada.",
        supplierRegisteredUntitled: "Factura registrada",
        supplierRegisteredAt: "Registrada {{when}}",
        supplierReplaceDesc: "Sube un archivo nuevo para sustituir la factura registrada.",
        supplierReplaceButton: "Cambiar factura",
        supplierReplaceSubmit: "Guardar sustitución",
        supplierReplaceSuccess: "Factura del proveedor sustituida",
        supplierReplaceError: "No se pudo sustituir la factura del proveedor",
        supplierButton: "Registrar factura recibida",
        supplierNumberLabel: "Número de factura",
        supplierNumberPlaceholder: "Ej. 2026/123",
        supplierDateLabel: "Fecha de factura (opcional)",
        supplierTotalLabel: "Total €",
        supplierExpectedTotal: "Debe coincidir con las líneas seleccionadas: {{amount}}",
        supplierFileLabel: "Archivo de factura (PDF o imagen)",
        supplierNumberRequired: "Introduce el número de factura",
        supplierFileRequired: "Selecciona el archivo de la factura",
        supplierFileTooLarge:
          "Archivo demasiado grande. Tamaño máximo {{max}}.",
        supplierFileUnsupported: "Sube una imagen o un PDF de la factura.",
        supplierTotalRequired: "Introduce el total de la factura",
        supplierTotalInvalid: "Importe no válido (p. ej. 1.234,56)",
        supplierTotalMismatch:
          "El total de la factura debe coincidir con las líneas seleccionadas ({{expected}}).",
        supplierSuccess: "Factura del proveedor registrada",
        supplierError: "No se pudo registrar la factura del proveedor",
        payTitle: "Emitir pago",
        payDesc: "Paga al vendedor mediante Revolut o registra un pago manual.",
        unavailableTitle: "Paso no listo",
        unavailableGoBack: "Volver",
        unavailableConfirm: "Continuar de todos modos",
        unavailableSummary: "Este paso siempre está disponible cuando hay líneas seleccionadas.",
        unavailableCollect:
          "El resumen aún no se ha enviado para todas las líneas seleccionadas. ¿Continuar de todos modos?",
        unavailableSupplier:
          "El resumen aún no se ha enviado para todas las líneas seleccionadas. ¿Continuar de todos modos?",
        unavailableInvoice:
          "Es posible que los pasos anteriores no estén completos para todas las líneas seleccionadas (resumen, cobro o factura recibida). ¿Continuar de todos modos?",
        unavailablePay:
          "Es posible que los pasos anteriores no estén completos para todas las líneas seleccionadas (resumen, factura o cobro). ¿Continuar de todos modos?",
      },
      revolut: {
        bannerTitle: "Payout de Revolut en curso",
        status: "Estado: {{status}}",
        referenceLabel: "Referencia del pago en Revolut",
        payButton: "Pagar con Revolut",
        referenceRequired: "Introduce una referencia para este payout Revolut",
        initiated: "Payout de Revolut iniciado",
        completedToast: "Payout Revolut completado — líneas actualizadas",
        pendingReconciliationLabel:
          "Reconciliación contable pendiente (fondos movidos en Revolut; reintentos automáticos)",
        failedToast: "Payout Revolut rechazado o cancelado",
        error: "No se pudo iniciar el payout de Revolut",
        legalRequired:
          "El beneficiario debe tener el perfil legal y el IBAN completos",
        blockedActive:
          "Ya hay un payout de Revolut activo para este beneficiario",
      },
    },
  },
} as const;
